var _path, _path2, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconEarthHeart48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6391 41.7489C30.3809 41.7489 38.2782 33.8516 38.2782 24.1098C38.2782 14.368 30.3809 6.4707 20.6391 6.4707C10.8973 6.4707 3 14.368 3 24.1098C3 33.8516 10.8973 41.7489 20.6391 41.7489Z",
    fill: "#D9D9D9",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2384_9520",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 37,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6391 41.7489C30.3809 41.7489 38.2782 33.8516 38.2782 24.1098C38.2782 14.368 30.3809 6.4707 20.6391 6.4707C10.8973 6.4707 3 14.368 3 24.1098C3 33.8516 10.8973 41.7489 20.6391 41.7489Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.11375
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2384_9520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6391 41.7489C30.3809 41.7489 38.2782 33.8516 38.2782 24.1098C38.2782 14.368 30.3809 6.4707 20.6391 6.4707C10.8973 6.4707 3 14.368 3 24.1098C3 33.8516 10.8973 41.7489 20.6391 41.7489Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4585 5.56641C24.4585 5.56641 20.7879 7.6751 20.7232 10.8727C20.6587 14.0703 24.8397 12.352 24.8397 14.6611C24.8397 16.9701 22.1141 17.3962 19.6617 15.0489C17.2093 12.7016 14.4923 12.4364 12.0566 14.5347C9.62092 16.633 9.22078 22.1535 13.4159 23.0081C17.6111 23.8627 18.2226 24.1958 18.2226 28.4423C18.2226 32.6889 18.775 33.608 22.0636 33.608C25.3522 33.608 23.5942 30.1732 24.8397 27.9484C26.0851 25.7235 28.2375 24.5623 28.2375 22.7535C28.2375 20.9446 24.0597 21.2574 24.8397 18.7322C25.6196 16.2072 29.3207 17.5759 31.115 16.5211C32.9094 15.4663 34.1368 11.3208 33.6469 10.8727C33.4208 10.6659 32.6118 9.49404 30.1305 7.98061C29.2372 7.43573 28.5507 6.73723 27.4629 6.3893C26.212 5.88536 24.4585 5.56641 24.4585 5.56641Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1615 45.6289L28.4743 37.539C26.8091 35.7866 26.675 33.0802 28.1588 31.1717C29.8243 29.0293 32.9161 28.6537 35.0462 30.335L36.1615 31.2152L37.7952 30.069C39.9828 28.5342 43.0019 29.0747 44.5211 31.2731C45.8168 33.148 45.6204 35.6745 44.0505 37.3267L36.1615 45.6289Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconEarthHeart48);
export default __webpack_public_path__ + "static/media/pictogramBeaconEarthHeart48.7b1a946e1d6b9e66c61b588392aabbfa.svg";
export { ForwardRef as ReactComponent };